// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/mountainsForst.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HOW IT WORKS — process section
   ============================================================ */

.hiw {
  position: relative;
  padding-block: var(--section-y);
  background: var(--bg);
}

.hiw__layout {
  position: relative;
}

.hiw__rail {
  position: absolute;
  left: calc(-1 * var(--sp-8));
  top: 0;
}

.hiw__eyebrow {
  color: var(--accent);
  display: block;
}

.hiw__headline {
  font-size: var(--fs-display);
  color: var(--c-forest);
  margin: var(--sp-2) 0 var(--sp-3);
}

.hiw__intro {
  font-size: var(--fs-lead);
  color: var(--text-muted);
  max-width: 46ch;
  line-height: var(--lh-body);
}

/* ── Tier rule: label + horizontal line + dot ── */
.hiw__tier-rule {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  margin: var(--sp-8) 0 var(--sp-5);
}
.hiw__tier-label {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: var(--track-eyebrow);
  text-transform: uppercase;
  color: var(--c-ink);
  white-space: nowrap;
}
.hiw__tier-line {
  flex: 1 1;
  height: 1px;
  background: var(--line);
}
.hiw__tier-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent);
  flex: 0 0 auto;
}

/* ── Before the retreat — 5 tiles ── */
.hiw__before-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: var(--sp-4);
}
@media (max-width: 1100px) {
  .hiw__before-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 640px) {
  .hiw__before-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.hiw__tile {
  position: relative;
  background: var(--c-cream);
  border: 1px solid var(--line);
  border-radius: 10px;
  padding-top: var(--sp-5);
  transition:
    box-shadow 0.25s var(--ease),
    border-color 0.25s var(--ease);
}
.hiw__tile--open {
  grid-column: 1 / -1;
  box-shadow: var(--shadow);
  border-color: var(--accent);
}

.hiw__tile-tag {
  position: absolute;
  top: -10px;
  left: var(--sp-4);
  background: var(--c-cream);
  border: 1px solid var(--line);
  border-radius: 4px;
  padding: 2px 8px;
  font-family: var(--font-body);
  font-size: 0.68rem;
  font-weight: 700;
  color: var(--accent);
}

.hiw__tile-inner {
  width: 100%;
  background: none;
  border: none;
  padding: var(--sp-2) var(--sp-4) var(--sp-4);
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hiw__tile-icon {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background: var(--c-sand);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.7rem;
  color: var(--c-ink);
  margin-bottom: var(--sp-3);
}

.hiw__tile-title {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: var(--fs-body);
  color: var(--c-ink);
  margin-bottom: var(--sp-2);
}

.hiw__tile-teaser {
  font-size: var(--fs-sm);
  color: var(--text-muted);
  line-height: var(--lh-body);
}

.hiw__tile-more {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: var(--sp-3);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--accent);
}

.hiw__tile-chevron {
  font-size: 0.75em;
  transition: transform 0.25s var(--ease);
}
.hiw__tile-chevron--flip {
  transform: rotate(180deg);
}

.hiw__tile-panel {
  overflow: hidden;
}
.hiw__tile-body {
  padding: 0 var(--sp-6) var(--sp-5);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  line-height: var(--lh-body);
  text-align: left;
}
.hiw__doc-list {
  margin: 0 var(--sp-6) var(--sp-5);
  padding-left: 1.1em;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
}
.hiw__doc-list li {
  font-size: var(--fs-xs);
  color: var(--text-muted);
  line-height: var(--lh-body);
}

/* ── The Retreat — dark hero panel, split layout ── */
.hiw__hero-tile {
  margin-top: var(--sp-6);
  display: grid;
  grid-template-columns: 1.15fr 1fr;
  align-items: stretch;
  background: var(--c-forest);
  border-radius: 14px;
  overflow: hidden;
}
@media (max-width: 900px) {
  .hiw__hero-tile {
    grid-template-columns: 1fr;
  }
}

.hiw__hero-left {
  padding: var(--sp-7) var(--sp-6);
  display: flex;
  flex-direction: column;
}

.hiw__hero-eyebrow {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: var(--track-eyebrow);
  text-transform: uppercase;
  color: var(--accent);
}

.hiw__hero-title {
  font-size: var(--fs-display);
  color: #fff;
  margin: var(--sp-2) 0 var(--sp-1);
}

.hiw__hero-squiggle {
  color: var(--accent);
  letter-spacing: -2px;
  margin-bottom: var(--sp-3);
}

.hiw__hero-teaser {
  font-size: var(--fs-lead);
  color: rgba(246, 239, 230, 0.92);
  line-height: var(--lh-body);
  max-width: 42ch;
}

.hiw__hero-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  margin-top: var(--sp-3);
  background: none;
  border: none;
  cursor: pointer;
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--c-sand);
}

.hiw__hero-full {
  overflow: hidden;
  margin-top: var(--sp-3);
  font-size: var(--fs-sm);
  color: rgba(246, 239, 230, 0.85);
  line-height: var(--lh-body);
  max-width: 46ch;
}

.hiw__hero-tags {
  margin-top: var(--sp-6);
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-5);
}

.hiw__hero-tag {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--c-sand);
  text-align: center;
  white-space: pre-line;
  min-width: 56px;
}
.hiw__hero-tag svg {
  font-size: 1.5rem;
  color: var(--c-sand);
}

.hiw__hero-right {
  position: relative;
  min-height: 280px;
}
.hiw__hero-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ── After the retreat — reintegration bar ── */
.hiw__after-tile {
  position: relative;
  margin-top: var(--sp-2);
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  background: var(--c-sand);
  border: none;
  border-radius: 12px;
  padding: var(--sp-5) var(--sp-6);
  cursor: pointer;
  text-align: left;
  overflow: hidden;
}

.hiw__after-num {
  position: absolute;
  top: var(--sp-4);
  left: var(--sp-4);
  font-family: var(--font-body);
  font-size: 0.68rem;
  font-weight: 700;
  color: var(--accent);
  background: var(--c-cream);
  border: 1px solid var(--line);
  border-radius: 4px;
  padding: 2px 8px;
}

.hiw__after-icon {
  flex: 0 0 auto;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--c-cream);
  border: 1px solid var(--line);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: var(--c-ink);
}

.hiw__after-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.hiw__after-title {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: var(--fs-h3);
  color: var(--c-ink);
}

.hiw__after-teaser {
  margin-top: 2px;
  font-size: var(--fs-sm);
  color: rgba(27, 27, 27, 0.65);
}

.hiw__after-full {
  overflow: hidden;
  display: block;
  margin-top: var(--sp-2);
  font-size: var(--fs-sm);
  color: rgba(27, 27, 27, 0.75);
  line-height: var(--lh-body);
}

.hiw__after-tile .hiw__tile-chevron {
  flex: 0 0 auto;
  color: rgba(27, 27, 27, 0.55);
  z-index: 1;
}

.hiw__after-botanical {
  position: absolute;
  right: -20px;
  top: -20px;
  bottom: -20px;
  width: 45%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / contain;
  opacity: 0.08;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/HowItWorks.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,MAAM;AACR;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAwB;EACxB;;kCAEgC;AAClC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,4CAA4C;EAC5C,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,sDAAsD;AACtD;EACE,uBAAuB;EACvB,aAAa;EACb,iCAAiC;EACjC,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,UAAU;EACV,8EAAuF;EACvF,aAAa;EACb,oBAAoB;AACtB","sourcesContent":["/* ============================================================\n   HOW IT WORKS — process section\n   ============================================================ */\n\n.hiw {\n  position: relative;\n  padding-block: var(--section-y);\n  background: var(--bg);\n}\n\n.hiw__layout {\n  position: relative;\n}\n\n.hiw__rail {\n  position: absolute;\n  left: calc(-1 * var(--sp-8));\n  top: 0;\n}\n\n.hiw__eyebrow {\n  color: var(--accent);\n  display: block;\n}\n\n.hiw__headline {\n  font-size: var(--fs-display);\n  color: var(--c-forest);\n  margin: var(--sp-2) 0 var(--sp-3);\n}\n\n.hiw__intro {\n  font-size: var(--fs-lead);\n  color: var(--text-muted);\n  max-width: 46ch;\n  line-height: var(--lh-body);\n}\n\n/* ── Tier rule: label + horizontal line + dot ── */\n.hiw__tier-rule {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-3);\n  margin: var(--sp-8) 0 var(--sp-5);\n}\n.hiw__tier-label {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: var(--track-eyebrow);\n  text-transform: uppercase;\n  color: var(--c-ink);\n  white-space: nowrap;\n}\n.hiw__tier-line {\n  flex: 1;\n  height: 1px;\n  background: var(--line);\n}\n.hiw__tier-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--accent);\n  flex: 0 0 auto;\n}\n\n/* ── Before the retreat — 5 tiles ── */\n.hiw__before-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: var(--sp-4);\n}\n@media (max-width: 1100px) {\n  .hiw__before-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media (max-width: 640px) {\n  .hiw__before-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.hiw__tile {\n  position: relative;\n  background: var(--c-cream);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding-top: var(--sp-5);\n  transition:\n    box-shadow 0.25s var(--ease),\n    border-color 0.25s var(--ease);\n}\n.hiw__tile--open {\n  grid-column: 1 / -1;\n  box-shadow: var(--shadow);\n  border-color: var(--accent);\n}\n\n.hiw__tile-tag {\n  position: absolute;\n  top: -10px;\n  left: var(--sp-4);\n  background: var(--c-cream);\n  border: 1px solid var(--line);\n  border-radius: 4px;\n  padding: 2px 8px;\n  font-family: var(--font-body);\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: var(--accent);\n}\n\n.hiw__tile-inner {\n  width: 100%;\n  background: none;\n  border: none;\n  padding: var(--sp-2) var(--sp-4) var(--sp-4);\n  cursor: pointer;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.hiw__tile-icon {\n  width: 68px;\n  height: 68px;\n  border-radius: 50%;\n  background: var(--c-sand);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.7rem;\n  color: var(--c-ink);\n  margin-bottom: var(--sp-3);\n}\n\n.hiw__tile-title {\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: var(--fs-body);\n  color: var(--c-ink);\n  margin-bottom: var(--sp-2);\n}\n\n.hiw__tile-teaser {\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n}\n\n.hiw__tile-more {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: var(--sp-3);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--accent);\n}\n\n.hiw__tile-chevron {\n  font-size: 0.75em;\n  transition: transform 0.25s var(--ease);\n}\n.hiw__tile-chevron--flip {\n  transform: rotate(180deg);\n}\n\n.hiw__tile-panel {\n  overflow: hidden;\n}\n.hiw__tile-body {\n  padding: 0 var(--sp-6) var(--sp-5);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  text-align: left;\n}\n.hiw__doc-list {\n  margin: 0 var(--sp-6) var(--sp-5);\n  padding-left: 1.1em;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  text-align: left;\n}\n.hiw__doc-list li {\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n}\n\n/* ── The Retreat — dark hero panel, split layout ── */\n.hiw__hero-tile {\n  margin-top: var(--sp-6);\n  display: grid;\n  grid-template-columns: 1.15fr 1fr;\n  align-items: stretch;\n  background: var(--c-forest);\n  border-radius: 14px;\n  overflow: hidden;\n}\n@media (max-width: 900px) {\n  .hiw__hero-tile {\n    grid-template-columns: 1fr;\n  }\n}\n\n.hiw__hero-left {\n  padding: var(--sp-7) var(--sp-6);\n  display: flex;\n  flex-direction: column;\n}\n\n.hiw__hero-eyebrow {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: var(--track-eyebrow);\n  text-transform: uppercase;\n  color: var(--accent);\n}\n\n.hiw__hero-title {\n  font-size: var(--fs-display);\n  color: #fff;\n  margin: var(--sp-2) 0 var(--sp-1);\n}\n\n.hiw__hero-squiggle {\n  color: var(--accent);\n  letter-spacing: -2px;\n  margin-bottom: var(--sp-3);\n}\n\n.hiw__hero-teaser {\n  font-size: var(--fs-lead);\n  color: rgba(246, 239, 230, 0.92);\n  line-height: var(--lh-body);\n  max-width: 42ch;\n}\n\n.hiw__hero-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  align-self: flex-start;\n  margin-top: var(--sp-3);\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--c-sand);\n}\n\n.hiw__hero-full {\n  overflow: hidden;\n  margin-top: var(--sp-3);\n  font-size: var(--fs-sm);\n  color: rgba(246, 239, 230, 0.85);\n  line-height: var(--lh-body);\n  max-width: 46ch;\n}\n\n.hiw__hero-tags {\n  margin-top: var(--sp-6);\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--sp-5);\n}\n\n.hiw__hero-tag {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: var(--c-sand);\n  text-align: center;\n  white-space: pre-line;\n  min-width: 56px;\n}\n.hiw__hero-tag svg {\n  font-size: 1.5rem;\n  color: var(--c-sand);\n}\n\n.hiw__hero-right {\n  position: relative;\n  min-height: 280px;\n}\n.hiw__hero-img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* ── After the retreat — reintegration bar ── */\n.hiw__after-tile {\n  position: relative;\n  margin-top: var(--sp-2);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: var(--sp-4);\n  background: var(--c-sand);\n  border: none;\n  border-radius: 12px;\n  padding: var(--sp-5) var(--sp-6);\n  cursor: pointer;\n  text-align: left;\n  overflow: hidden;\n}\n\n.hiw__after-num {\n  position: absolute;\n  top: var(--sp-4);\n  left: var(--sp-4);\n  font-family: var(--font-body);\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: var(--accent);\n  background: var(--c-cream);\n  border: 1px solid var(--line);\n  border-radius: 4px;\n  padding: 2px 8px;\n}\n\n.hiw__after-icon {\n  flex: 0 0 auto;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--c-cream);\n  border: 1px solid var(--line);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  color: var(--c-ink);\n}\n\n.hiw__after-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 1;\n}\n\n.hiw__after-title {\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: var(--fs-h3);\n  color: var(--c-ink);\n}\n\n.hiw__after-teaser {\n  margin-top: 2px;\n  font-size: var(--fs-sm);\n  color: rgba(27, 27, 27, 0.65);\n}\n\n.hiw__after-full {\n  overflow: hidden;\n  display: block;\n  margin-top: var(--sp-2);\n  font-size: var(--fs-sm);\n  color: rgba(27, 27, 27, 0.75);\n  line-height: var(--lh-body);\n}\n\n.hiw__after-tile .hiw__tile-chevron {\n  flex: 0 0 auto;\n  color: rgba(27, 27, 27, 0.55);\n  z-index: 1;\n}\n\n.hiw__after-botanical {\n  position: absolute;\n  right: -20px;\n  top: -20px;\n  bottom: -20px;\n  width: 45%;\n  background: url(\"../../../public/assets/mountainsForst.png\") no-repeat center / contain;\n  opacity: 0.08;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
